define.alias("shared/utils/social-profile-link", "media/utils/social-profile-link");